import { Link } from "react-router-dom";
import { mangas } from "@/mocks/mangas";

const ranking = [...mangas].sort((a, b) => b.popular - a.popular).slice(0, 8);

function fmt(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1)} 万`;
  return `${n}`;
}

export default function RankingSection() {
  return (
    <section className="w-full bg-background-100" aria-labelledby="ranking-heading">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-sm font-medium text-accent-600">TOP LIST</span>
            <h2 id="ranking-heading" className="mt-1 font-heading text-2xl text-foreground-900 md:text-3xl">
              漫画排行榜大全
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              依据漫画人气排行与读者口碑综合排序，掌握当下最热门的漫画作品。
            </p>
          </div>
          <Link
            to="/category"
            className="group flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            完整人气排行
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {ranking.map((m, idx) => (
            <li key={m.slug}>
              <Link
                to={`/category/${m.category}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-1"
              >
                <span
                  className={`font-heading text-2xl ${
                    idx < 3 ? "text-accent-500" : "text-background-400"
                  }`}
                >
                  {idx + 1}
                </span>
                <div className="relative h-16 w-12 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={m.cover}
                    alt={m.title}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                    {m.title}
                  </h3>
                  <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-fire-line text-primary-500" />
                    {fmt(m.popular)} 人气
                  </p>
                  <p className="mt-0.5 flex items-center gap-1 text-xs text-accent-600">
                    <i className="ri-star-fill" />
                    {m.rating}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}